import { DOCUMENT } from '@angular/common';
import { AfterContentChecked, Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { GenericModalComponent } from './generic-modal/generic-modal.component';
import { Router } from '@angular/router';
import DadosCertificadoModel from './model/dados-certificado.model';
import DadosRegistroModel from './model/dados-registro.model';
import { CertificadoService } from './services/certificado.service';
import { ModalAjudaAtivacaoKriptonitaComponent } from './modal-ajuda-ativacao-kriptonita/modal-ajuda-ativacao-kriptonita.component';
import { RegistroService } from './services/registro.service';
import { MessageService } from './services/message.service';
import { Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';
import { API_DOWNLOAD_KRYPTONITA } from './app.api';
import { GlobalCripto } from './global/global-constants'
import { ModalCryptoComponent } from './modal-Crypto/modal-crypto.component';
import { CnsController } from './cns-controller';
declare const xabo: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent extends CnsController implements OnInit {

  private sign: any;
  private jaInicializado = false;
  
  public dadosCertificado: DadosCertificadoModel;
  public permiteRegistro$: Observable<Boolean[]>;
  public permiteRegistro: boolean;
  // public possuiRegistro: boolean;
  public dadosRegistro: DadosRegistroModel;
  public certificado;
  public certificadoValido = false;
  public certificadoBloqueado: any;
  public carregouConteudo$: Observable<boolean>

  constructor(
    private certificadoService: CertificadoService,
    private registroService: RegistroService,
    private dialog: MatDialog,
    private router: Router,
    private messageService: MessageService,
    @Inject(DOCUMENT) private document: Document) {
    super(router, dialog, messageService);
  }

  ngOnInit() {
    if (!this.jaInicializado) {
      this.jaInicializado = true;
      setTimeout(() => this.verificaAmbienteUsuario(), 2000);
      this.autenticacoesCertificado();
    }
  }

  async autenticacoesCertificado() {

    await this.atualizarTokenSessao();

    await this.obterDadosCertificado();

   // await this.verificarBloqueioLCR();

    await this.carregarDadosRegistro();

   // await this.certificadoService.verificarBloqueioCertificado(this.dadosCertificado);

   // const carregou: any = await this.registroService.tratarSituacaoRegistro(this.dadosRegistro);

   // this.carregouConteudo$ = of(carregou);
  }


  private messageError = '';
  private titulo = '';
  private action;
  userChecked = undefined;


  openDialog(mensagem: string, action: string, titulo: string, labelconfirmar: string, labelcancelar: string, help: boolean): string {
    this.dialog.open(GenericModalComponent, { data: { mensagem, action, titulo, labelconfirmar, labelcancelar, help } });
    return mensagem;
  }

  openDialogHelp(titulo: string) {
    this.dialog.open(ModalAjudaAtivacaoKriptonitaComponent, { data: { titulo } });
  }

  private async verificaAmbienteUsuario() {
    if (!this.userChecked) {   
     // this.verificaNavegadorUsuario();
      await this.verificaAPICriptoCNS(); 
    }
  }

  verificaNavegadorUsuario() {
    this.action = 'https://www.google.com/intl/pt-BR/chrome/';
    this.titulo = 'Atenção!';
    if (navigator.userAgent.indexOf('Chrome') === -1) {
      this.openDialog('O site só da suporte para o navegador Chrome. Favor utilizar o mesmo.', this.action, this.titulo, 'Sim', 'Não', false);
    }
  }
 
  async verificaAPICriptoCNS() {
    this.action = API_DOWNLOAD_KRYPTONITA;
    this.sign = await xabo.queryInterface({ compatibilityMode: true }).then((api) => {  
         console.log('API ATIVA: ' + api.signet);   
         GlobalCripto.apiAtiva = api.signet;
         GlobalCripto.clientAPI = api;
         })      
     .catch((reason) => {
       this.messageError = reason.statusText;  
       GlobalCripto.apiAtiva = 'erro';
       console.log('Erro na tentativa de carregar a CriptoCns. ');
       console.log('Motivo:' + reason.reason ) ;  
       console.log('Código: '+ reason.result) ;
       console.log("Mensagem: " +  this.messageError);    
     })  
     .finally(() => {
       this.userChecked = true;
       if (GlobalCripto.apiAtiva === 'erro' || GlobalCripto.apiAtiva === undefined){    
         GlobalCripto.clientAPI = null;  
         this.dialog.open(ModalCryptoComponent, { data: { action: this.action}, width: '60%'});
       }
     })
     ;    
    }

private async atualizarTokenSessao() {

    return new Promise(resolve => {

      // Só busca token se não existir no sessionStorage
      if (!sessionStorage['token']) {
        this.certificadoService.obterToken()
          .then(token => {
            sessionStorage['token'] = token
            resolve(token)
          })
          .catch(err => {
            console.error('Erro em chamada GET por TOKEN !', err)
            const msgErro: string = 'TOKEN';
            this.carregouConteudo$ = of(true);
            this.trataErro(err, msgErro);
          })
      } else {
        // Reutiliza token existente
        resolve(sessionStorage['token'])
      }

    })
  }

  private async obterDadosCertificado() {

    return new Promise(resolve => {

      if (!sessionStorage['dadosCertificado']) {
        this.certificadoService.obterCertificadoPorToken()
          .then(data => {
            this.dadosCertificado = data;
            sessionStorage['dadosCertificado'] = JSON.stringify(this.dadosCertificado)
            resolve(this.dadosCertificado)
          })
          .catch(err => {
            console.error('Erro ao converter Token-Certificado: ' + err)
          })

      } else {
        this.dadosCertificado = JSON.parse(sessionStorage['dadosCertificado'])
        resolve(this.dadosCertificado)
      }

    })

  }

  private async verificarBloqueioLCR() {

    const $lcr = this.certificadoService.verificarBloqueioLCR(this.dadosCertificado);

    const lcrObservable = {
      next: data => {
      },
      error: err => {
        console.error(err);
        this.mostraAcessoNegado('Erro LCR: ' , err.error.errors[0].mensagem);
      },
      done: () => { }
    }

    $lcr.subscribe(lcrObservable);
  }

  private async carregarDadosRegistro() {

    return new Promise(resolve => {
      const registro = sessionStorage['dadosRegistro'];
      if (!registro || registro === 'undefined') {
        const registroObservable = this.registroService.consultarSituacaoRegistro(this.dadosCertificado).pipe()
        const registroObserver = {
          next: data => {
            if (data && data['data']) {
              this.setardadosRegistro(data);
              sessionStorage['dadosRegistro'] = this.dadosRegistro !== undefined ? JSON.stringify(this.dadosRegistro) : undefined;
            }
          },
          error: err => {
            console.error('Erro ao carregar Registro: ' + err)
            const msgErro: string = 'NODE';
            this.carregouConteudo$ = of(true);
            this.trataErro(err, msgErro);
          },
          complete: () => {
            resolve(this.dadosRegistro)
          }
        }

        registroObservable.subscribe(registroObserver)

      } else {
        this.dadosRegistro = sessionStorage['dadosRegistro'] !== undefined ? JSON.parse(sessionStorage['dadosRegistro']) : undefined
        resolve(this.dadosRegistro)
      }
    })

  }

  setardadosRegistro(data) {
    this.dadosRegistro = new DadosRegistroModel();
    this.dadosRegistro.bloqueado = data['data']['bloqueado']==='0'? false:true ;
    this.dadosRegistro.situacao =  Number(data['data']['situacao']);
    this.dadosRegistro.nu_certificado = Number(data['data']['nuCertificado']);
    this.dadosRegistro.no_responsavel = data['data']['noResponsavel'];
    this.dadosRegistro.nu_cpf = Number(data['data']['nuCpf']);
    this.dadosRegistro.co_certificado= data['data']['coCertificado'];
    this.dadosRegistro.de_nome_comum= data['data']['deNomeComun'];
    this.dadosRegistro.no_autoridade_certificadora= data['data']['noAutoridadeCertificadora'];
    this.dadosRegistro.nu_perfil= Number(data['data']['nuPerfil']);
    this.dadosRegistro.nu_pis= Number(data['data']['nuPis']);
    this.dadosRegistro.nu_entidade_certificada= Number(data['data']['nuEntidadeCertificada']);
    this.dadosRegistro.de_razao_social= data['data']['deRazaoSocial'];
    this.dadosRegistro.nu_inscricao= data['data']['nuInscricao'];
    this.dadosRegistro.de_perfil= data['data']['dePerfil'];
    this.dadosRegistro.ic_tipo_perfil= Number(data['data']['icTipoPerfil']);
    this.dadosRegistro.ic_tipo_restricao= Number(data['data']['icTipoRestricao']);
  }

}




